import { Dispatch, SetStateAction, useMemo } from 'react';
import { goalNameToKey } from '../pacingUtils';
import { RecursivePacingBar } from './RecursivePacingBar';

interface PacingBarsDashboardProps {
  pacingBarsData: Record<string, any>;
  activeDimensions: string[];
  simplicity: string;
  setSimplicity: Dispatch<SetStateAction<string>>;
  longestText: number;
  sortOption: string;
  start: string;
  end: string;
  goalName: string;
  isActual: boolean;
  currentGoalValue: string;
}

export const PacingBarsDashboard = ({
  pacingBarsData,
  activeDimensions,
  simplicity,
  setSimplicity,
  longestText,
  sortOption,
  start,
  end,
  goalName,
  isActual,
  currentGoalValue
}: PacingBarsDashboardProps) => {
  const goalKey = useMemo(() => goalNameToKey(currentGoalValue), [currentGoalValue]);

  // A segmented ratio goal anchors below the root, so the root/total node is goalless and ships no
  // `booked` — guard it (an unguarded read crashes the whole bars render before the child bars draw).
  const maxGoal = useMemo(() => pacingBarsData.booked?.[goalKey], [pacingBarsData, goalKey]);

  return (
    <div className='pacing-bars-dashboard'>
      <RecursivePacingBar
        start={start}
        end={end}
        pacingBarsData={pacingBarsData}
        simplicity={simplicity}
        setSimplicity={setSimplicity}
        maxGoal={maxGoal}
        goalKey={goalKey}
        longestText={longestText}
        isActual={isActual}
        goalName={goalName}
        activeDimensions={activeDimensions}
        sortOption={sortOption}
        isTotal
      />
    </div>
  );
};
